import Vue from 'vue';
import Vuex from 'vuex';
import VuexPersist from 'vuex-persist';

Vue.use(Vuex);

const getDefaultState = () => {
  return {
    auth: {
      isAuthenticated: false,
      /** @type AuthenticatedUserDto */
      user: {},
      permissions: {}
    },
    isGlobalLoading: false,
    untranslatedMessages: [],
    notifications: {
      /** @type {NotificationDto[]} */
      activeNotifications: [],
      numberOfActive: 0,
      lastPolledAt: null
    }
  };
};

const state = getDefaultState();

const mutations = {
  SET_AUTH (state, auth) {
    state.auth = auth;
  },
  SET_IS_GLOBAL_LOADING (state, isGlobalLoading) {
    state.isGlobalLoading = isGlobalLoading;
  },
  ADD_UNTRANSLATED_MESSAGE (state, untranslatedMessageKey) {
    if (!state.untranslatedMessages.includes(untranslatedMessageKey)) {
      state.untranslatedMessages.push(untranslatedMessageKey);
    }
  },
  CLEAR_UNTRANSLATED_MESSAGES (state) {
    state.untranslatedMessages = [];
  },
  SET_NOTIFICATIONS (state, {activeNotifications, numberOfActive, lastPolledAt}) {
    state.notifications.activeNotifications = activeNotifications;
    state.notifications.numberOfActive = numberOfActive;
    state.notifications.lastPolledAt = lastPolledAt;
  }
};

const actions = {
  setAuth (store, auth) {
    store.commit('SET_AUTH', auth);
  },
  setIsGlobalLoading (store, isGlobalLoading) {
    store.commit('SET_IS_GLOBAL_LOADING', isGlobalLoading);
  },
  addUntranslatedMessage (store, untranslatedMessageKey) {
    store.commit('ADD_UNTRANSLATED_MESSAGE', untranslatedMessageKey);
  },
  clearUntranslatedMessages (store) {
    store.commit('CLEAR_UNTRANSLATED_MESSAGES');
  },
  setNotifications (store, notifications) {
    store.commit('SET_NOTIFICATIONS', notifications);
  }
};

const getters = {
  auth (state) {
    return state.auth;
  },
  /** @return AuthenticatedUserDto */
  user (state) {
    return state.auth.user;
  },
  isAuthenticated (state) {
    return state.auth && state.auth.isAuthenticated;
  },
  permissions (state) {
    return state.auth.permissions;
  },
  isGlobalLoading (state) {
    return state.isGlobalLoading;
  },
  untranslatedMessages (state) {
    return state.untranslatedMessages;
  },
  notifications (state) {
    return state.notifications;
  }
};

const vuexPersist = new VuexPersist({
  key: 'stayin_office',
  storage: localStorage
});

export default new Vuex.Store({
  state,
  getters,
  actions,
  mutations,
  plugins: [vuexPersist.plugin]
});
